import React from 'react'
import { AiFillLinkedin , AiFillGithub } from 'react-icons/ai'
export default function Contact() {
  return (
    <div className='px-6 max-w-[1000px] mx-auto glass grid md:grid-cols-2 place-items-center mt-6' id="Contact">
            <ul className='my-auto pr-6 '>
                <li className='flex'
                                    data-aos="fade-up"
                                    data-aos-delay='60'
                                    data-aos-duration='1400'
                >
                    <AiFillLinkedin className='w-[70px] h-auto text-sky-700'/>
                    <div className='m-5'>
                        <h3 className='text-lg font-bold text-sky-500 '>Contact </h3>
                        <p className='text-gray-500'>Whatsapp : +213676917753</p>
                        <p className='text-gray-500' >Email : Youcefbada04@gmail.com</p>
                    </div>
                </li>
                <li className='flex' 
                                    data-aos="fade-up"
                                    data-aos-delay='60'
                                    data-aos-duration='1400'
                                    >
                    <AiFillGithub className='w-[70px] h-auto text-gray-800'
                    />
                    <div className='m-5'>
                        <h3 className='text-lg font-bold text-sky-500 '>Working Hours </h3>
                        <p className='text-gray-500'>Mon-Fri : 9AM - 8PM</p>
                    </div>
                </li>
            </ul>
            <form action = "https://getform.io/f/raeqweka" method="POST" className='max-w-6xl p-5 md:p-12 ' id="form" 
                    data-aos="fade-up"
                    data-aos-delay='60'
                    data-aos-duration='1400' 
            >
                <input
                    type='text'
                    placeholder='Your Name ...'
                    id='name'
                    name='name'
                    className='mb-2 w-full rounded-md border border-gray-400 py-2 pl-2 pr-4 '
                />
                <input
                    type='email'
                    placeholder='Your Email ...'
                    id='email'
                    name='email'
                    className='mb-2 w-full rounded-md border border-gray-400 py-2 pl-2 pr-4 '
                />                
                <textarea
                    placeholder='Your Massege ...'
                    id='textarea'
                    cols="30"
                    rows="4"
                    name='textarea'
                    className='mb-2 w-full rounded-md border border-gray-400 py-2 pl-2 pr-4 '
                />
                <button type='submit' className='w-full py-3 rounded-md text-gray-200 font-semibold text-xl 
                bg-gradient-to-r from-sky-600 via-sky-400 to-sky-300'>Send Message</button>
            </form>
    </div>
  )
}

